module.exports = __webpack_public_path__ + "images/emoji/smirk.44b0d79ea63e9bc1a674.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/smirk.png
// module id = d4Bf
// module chunks = 14